<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">我的草稿</span> -->

  <el-container class="list_main_content" :style="conheight">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">我的草稿分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container >
      <collapse-search>
      <div class="content_top_wrap">
        <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button size="small" type="primary" @click="search('find')">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>

        <!-- <div class="content_top_wrap_form">
          <el-input
            class="form_input"
            size="small"
            clearable
            placeholder="事项名称/流程名称/工单号"
            prefix-icon="el-icon-search"
            v-model="tableData"
            @keyup.enter.native="searchEnterFun"
          ></el-input>
          <div class="form_date_picker">
            <a class="search_form_label">创建时间</a>
            <el-date-picker
              v-model="date"
              type="datetimerange"
              size="small"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
        </div>
        <el-row>
          <el-col :span="24">
            <el-button
              style="margin-left: 16px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh" style="margin-left: 16px"
              >重置</el-button
            >
          </el-col>
        </el-row> -->
      </div>
      </collapse-search>
      <el-main class="request_content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          style="width: 100%;"
          header-cell-class-name="myRequest-header-row"
          row-class-name="myRequest-row"
          size="medium"
          height="100%"
          v-loading.fullscreen.lock="fullscreenLoading"
          :default-sort="{ prop: 'status,createTime', order: 'descending' }"
        >
          <el-table-column
            type="index"
            width="60"
            align="center"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="workOrderNo"
            width="120"
           sortable
            align="left"
            label="工单号"
          ></el-table-column>
          <el-table-column label="事项名称" >
            <template slot-scope="scope">
              <span
                class="myRequest-subject"
                @click="handleRowClick(scope.row)"
                >{{ scope.row.subject }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="流程名称"
           
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procDefName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="left"
            width="160"
            sortable
          ></el-table-column>
          <!-- <el-table-column prop="creator" label="发起人" align="left" width="180"></el-table-column> -->
          <el-table-column label="操作" align="left" width="100">
            <template slot-scope="scope" >
              <a class="request" @click="deleteDraft(scope.row.id)" v-if="scope.row.status == 'draft'">删除</a>
              <a class="request" @click="deleteBpm(scope.row.id)" v-if="
                  scope.row.status == 'manualend' ||
                    scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' &&
                      scope.row.backToStart == true)
                ">删除</a>

              <!-- <el-button
                v-if="scope.row.status == 'draft'"
                size="mini"
                type="danger"
                @click="deleteDraft(scope.row.id)"
                >删除</el-button
              >
              <el-button
                v-if="
                  scope.row.status == 'manualend' ||
                    scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' &&
                      scope.row.backToStart == true)
                "
                size="mini"
                type="danger"
                @click="deleteBpm(scope.row.id)"
                >删除</el-button
              > -->
              <el-button
                style="margin-top: 0px;"
                v-if="
                  scope.row.status == 'revokeToStart' ||
                    scope.row.status == 'backToStart' ||
                    (scope.row.status == 'back' &&
                      scope.row.backToStart == true)
                "
                size="mini"
                type="danger"
                @click="doEndProcessById(scope.row.id)"
                >终止</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row style="float: right;display: initial;">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-row>
      </el-footer>
      <el-dialog
        title="撤回到发起人"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          placeholder="请输入撤回意见"
          v-model="opinion"
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRevoke" size="small"
            >确 定</el-button
          >
          <el-button @click="exitRevoke" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </el-container>
  </el-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process.js";
import searchForm from "@/components/common/searchForm.vue";
export default {
  name: "myDraft",
  components: {
    FlowTree,
    searchForm
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      asideShow: false,
      tableData: "",
      date: "",
      fullscreenLoading: true,
      dialogFormVisible: false,
      opinion: "",
      currentTree: "",
      id: "",
      statusData: "",
      conheight: { height: "" },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "revoke",
          label: "撤回",
        },
        {
          value: "draft",
          label: "草稿",
        },
        {
          value: "back",
          label: "驳回",
        },
        {
          value: "end",
          label: "结束",
        },
        {
          value: "running",
          label: "运行中",
        },
      ],
      conheight:{ height:'' },
      searchOptions: [
        {
          property: "a.subject_",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "a.work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        }
      ]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total,
  }),
  methods: {
     //页面高度
    getHeight(){
      this.conheight.height = window.innerHeight -64 + "px";
    },
    //选择状态查询
    statusChange(value) {
      this.statusData = value;
      this.search("find");
    },
    handleClose(done) {
      this.dialogFormVisible = true;
    },
    //逻辑删除流程实例
    deleteBpm(id) {
      this.$confirm("确认删除此流程?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$store.dispatch("storeProcess/restore", id).then(() => {
          this.search("find");
        });
      });
    },
    //终止流程
    doEndProcessById(id) {
      this.$confirm("确认终止此流程?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false
      }).then(() => {
        this.$store.dispatch("storeProcess/doEndProcessById", id).then(() => {
          this.search("find");
        });
      });
    },
    //删除草稿
    deleteDraft(id) {
      this.$store.dispatch("storeProcess/removeDraftById", id).then(() => {
        this.search("find");
      });
    },
    //撤回到发起人
    handleRevoke(id, status) {
      if (status == "revokeToStart") {
        this.$message.warning("已撤回，不能再撤回");
        return false;
      }
      this.dialogFormVisible = true;
      this.id = id;
    },
    saveRevoke() {
      if (this.opinion == "") {
        this.$message.warning("请填写撤回意见");
        return false;
      }
      let data = {
        instanceId: this.id,
        isHandRevoke: false,
        cause: this.opinion,
      };
      this.$store.dispatch("storeProcess/revokeInstance", data).then(() => {
        this.dialogFormVisible = false;
        this.opinion = "";
        this.search();
      });
    },
    exitRevoke() {
      this.dialogFormVisible = false;
      this.opinion = "";
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      querys.push({
          property: "a.status_",
          value: "draft",
          operation: "EQUAL",
          relation: "AND"
      })
      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getMyRequestByPagination", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });

      // this.openFullScreen();
      // if (str == "find") {
      //   this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      // }
      // let querys = []; //查询条件
      // let queryFilter = {};
      // let pageBean = { pageBean: this.pagination };
      // let beginDate = ""; //开始时间
      // let endDate = ""; //结束时间
      // let group = "main"; //判断条件
      // if (
      //   this.tableData == "" &&
      //   this.statusData == "" &&
      //   (this.date == "" || this.date == null)
      // ) {
      //   if (this.currentTree != "") {
      //     querys = [
      //       {
      //         property: "a.type_id_",
      //         value: this.currentTree,
      //         group: "typeId",
      //         operation: "IN",
      //         relation: "AND"
      //       }
      //     ];
      //   }
      // } else {
      //   if (
      //     this.tableData != "" &&
      //     this.statusData != "" &&
      //     this.date != "" &&
      //     this.date != null
      //   ) {
      //     group = "time";
      //   }
      //   if (this.date != null && this.date != "") {
      //     beginDate = utils.formatDate(this.date[0].getTime());
      //     endDate = utils.formatDate(this.date[1].getTime());
      //   }
      //   if (this.tableData) {
      //     querys.push({
      //       property: "a.proc_def_name_",
      //       value: this.tableData,
      //       group: "tableData",
      //       operation: "LIKE",
      //       relation: "OR"
      //     });
      //     querys.push({
      //       property: "a.subject_", 
      //       value: this.tableData,
      //       group: "tableData",
      //       operation: "LIKE",
      //       relation: "OR",
      //     });
      //     querys.push({
      //       property: "a.work_order_no",
      //       value: this.tableData,
      //       group: "tableData",
      //       operation: "LIKE",
      //       relation: "OR"
      //     });
      //   }
      //   if (beginDate && endDate) {
      //     querys.push({
      //       property: "a.create_time_",
      //       value: [beginDate, endDate],
      //       group: group,
      //       operation: "BETWEEN",
      //       relation: "AND"
      //     });
      //   }

      //   if (this.statusData) {
      //     querys.push({
      //       property: "a.status_",
      //       value: this.statusData,
      //       group: "status",
      //       operation: "LIKE",
      //       relation: "AND"
      //     });
      //   }

      //   if (this.currentTree) {
      //     querys.push({
      //       property: "a.type_id_",
      //       value: this.currentTree,
      //       group: "typeId",
      //       operation: "IN",
      //       relation: "AND",
      //     });
      //   }
      // }
      // if (this.defKey) {
      //   querys.push({
      //     property: "a.proc_def_key_",
      //     value: this.defKey,
      //     operation: "EQUAL",
      //     relation: "AND"
      //   });
      // }
      // if(!querys){
      //     querys = [];
      // }
      // querys.push({
      //     property: "a.status_",
      //     value: "draft",
      //     operation: "EQUAL",
      //     relation: "AND"
      // })
      // queryFilter = { pageBean: this.pagination, querys };
      // this.$store
      //   .dispatch("storeProcess/getMyRequestByPagination", queryFilter)
      //   .then(() => {
      //     this.fullscreenLoading = false;
      //   });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      if (row.status == "draft") {
        //this.$router.push("/start/" + row.procDefId + "/" + row.id);
        url += "/start/" + row.procDefId + "/" + row.id;
      } else if (row.status == "end" || row.status == "manualend") {
        //this.$router.push("/instRead/" + row.id+"/myRequest");
        url += "/instRead/" + row.id + "/myRequest";
      } else {
        //this.$router.push("/inst/" + row.id + "/request");
        url += "/inst/" + row.id + "/request";
      }
      url += "?token=" + token;
      let winObjEI = window.open(url,"_blank","width="+(window.screen.availWidth-10)+",height="+(window.screen.availHeight-70));
      let isClose = 1;
      let this_ = this;
      //关闭open页面时刷新父页面列表
      let loop = setInterval(function() {
        if (winObjEI.closed && isClose == 1) {
          isClose--;
          //这里写刷新代码
          this_.search("find");
          clearInterval(loop);
        }
      }, 1000);
    },
    //子组件传值父组件(我的请求分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let querys = [{
            property:"a.status_",
            value:"draft",
            relation:"AND",
            operation:"EQUAL"
        }]
        let pageBean = { pageBean: this.pagination,querys:querys };
        
        this.$store
          .dispatch("storeProcess/getMyRequestByPagination", pageBean)
          .then(() => {
            //页面加载调用myRequest.js里面的分页方法
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      let pageBean = {};
      return process.getMyDraftCount(pageBean);
    }
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
    this.getHeight();
    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND"
      });
    }
    querys.push({
        property: "a.status_",
        value: "draft",
        operation:"EQUAL",
        relation:"AND"
    })
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getMyRequestByPagination", pageBean)
      .then(() => {
        //页面加载调用myRequest.js里面的分页方法
        this.fullscreenLoading = false;
      });
  },
    mounted(){
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}
/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 

/deep/ .request{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #E70D0D !important;
  margin-right: 4px !important;
}

/deep/ .el-badge{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .el-collapse-item__header{
  padding: 0px 24px 0px 0px !important;
  margin: 0px !important;
}

    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }

/deep/.el-table th{
  height: 48px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}


/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
  background-color:#EDF6FB !important;
    .myRequest-subject{
      color: #1890FF !important;
    }
    .myRequest-subject-read{
      color: #1890FF !important;
    }
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.myRequest-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}


.el-container {
  background-color: #fff;
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
}
.el-header {
  border-bottom: 1.5px solid #ededed;
}
/deep/.el-tag {
  padding-left: 3px;
  padding-right: 3px;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}

.myRequest-subject {
  cursor: pointer;
}

.myRequest-subject {
  color: $--theme-color;
}

.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}
/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.request_content {
  padding: 0 24px 0px 24px;
}
/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 0px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.form-content-wrap {
  padding: 0 20px 20px 20px;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
    scrollbar-width: none;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 24px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
</style>
